/**
 * Labstep
 *
 * @module core/DataGrid/ColumnHeader
 * @desc Default DataGrid ColumnHeader
 */

import classnames from 'classnames';
import { Flex } from 'labstep-web/core/Flex';
import { Icon } from 'labstep-web/core/Icon';
import type React from 'react';
import { useRef } from 'react';
import { useDoubleHeaderStyle } from './hooks';
import styles from './styles.module.scss';
import type { DataGridColumnHeaderProps } from './types';

export enum DataGridColumnHeaderMergeAsTypes {
  /** Parent of merged column header */
  parent = 'parent',
  /** Child of merged column header */
  child = 'child',
}

export const DataGridColumnHeader: React.FC<
  DataGridColumnHeaderProps
> = ({
  onClick,
  displayName,
  mergeAs,
  icon,
  cornerIcon,
  secondaryHeader,
  action,
}) => {
  const ref = useRef<HTMLDivElement | null>(null);
  const style = useDoubleHeaderStyle(ref, mergeAs);

  // Centered styling if action only
  const isActionOnly = !displayName;

  return (
    <div
      ref={ref}
      className={classnames(styles.defaultContainer, {
        [styles.clickable]: !!onClick,
        [styles.actionContainer]: isActionOnly,
      })}
      style={style}
      onClick={onClick}
    >
      {!isActionOnly && (
        <div className={styles.title}>
          {icon && <Icon name={icon} cornerIcon={cornerIcon} />}{' '}
          <Flex column>
            {displayName}
            {secondaryHeader && (
              <span className={styles.secondaryHeader}>
                {secondaryHeader}
              </span>
            )}
          </Flex>
        </div>
      )}
      {action}
    </div>
  );
};
